<template>
  <span
    >{{ first }}<span style="color: red">{{ center }}</span
    >{{ end }}
  </span>
</template>
<script>
export default {
  data() {
    return {
      first: "", //前面的
      center: "",
      end: "", //后面的
    };
  },
  props: ["title", "repeatTitle"],
  methods: {
    update() {
      this.first = this.center = this.end = "";
      if (!this.title) {
        return;
      }
      let len2 = this.repeatTitle.length;
      let reg = new RegExp(this.repeatTitle, "i");
      let arr = this.title.match(reg);
      if (Array.isArray(arr) && arr.length) {
        this.center = arr[0];
      } else {
        this.center = "";
        this.first = this.title;
        return;
      }
      if (this.center) {
        let position = this.title.indexOf(this.center);
        this.first = this.title.substring(0, position);
        this.end = this.title.substring(position + len2);
      }
    },
  },
  watch: {
    title: {
      handler(val) {
        this.update();
      },
      immediate: true,
    },
    repeatTitle: {
      handler(val) {
        this.update();
      },
    },
  },
};
</script>
<style scoped></style>
